import { render, staticRenderFns } from "./Liste.vue?vue&type=template&id=bc6bc8aa&"
import script from "./Liste.vue?vue&type=script&lang=js&"
export * from "./Liste.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports